import styled from 'styled-components';

export const HomeWrapper = styled.div`
  width: 90vw;
  max-width: 1600px;
  padding: 2rem;
  margin: 0 auto;
  h2 {
    font-weight: 400;
  }
`;

export const CategoriasWrapper = styled.section`
  margin-top: 8rem;
`;

export const ProductosWrapper = styled.section`
  padding-top: 5rem;
`;

export const RecomendadosWrapper = styled.section`
  margin-top: 5rem;
  width: 100%;

  h2 {
    font-weight: 400;
  }
`;

export const ButtonContainerStyled = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 3rem;
`;
